import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const DropdownMenuItemIcon = styled(FontAwesomeIcon)`
    width: 15px;
`;

export default DropdownMenuItemIcon;